import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { TipTapEditor } from '../../TipTap';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
});

/**
 * Rawtext - Read-only rich text display component
 * 
 * Displays HTML content in a read-only view.
 * Used in form builders to preview rich text answers.
 */
class Rawtext extends React.Component {
  render() {
    const { classes, data } = this.props;
    
    try {
      return (
        <div className={classes.root}>
          <TipTapEditor
            value={data?.defaultContent || ''}
            readOnly={true}
            showToolbar={false}
            minHeight="400px"
          />
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

Rawtext.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Rawtext);
